import { Button, Flex } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import PolicyCheckHOC from '@v2/commons/HOC/policyCheckHOC'
import { POLICIES } from '@v2/commons/config'
import { useState } from 'react'

import { Icons } from 'src/common/components/ui'

import useChatMessages from '../hooks/useChatMessages.hook'
import AddMessage from './AddNewMessage/addMessage.component'
import ChatList from './ChatMessageList/chatMessageList.component'
import styles from './chat-component.module.scss'

const ChatMessages = ({ chatId }: { chatId: string }) => {
  const [editMode, setEditMode] = useState(false)
  const { messages, addChatMessage, addChatMessageMutationStatus } =
    useChatMessages(chatId)

  const onAddNote = (content: string) => {
    addChatMessage({
      data: {
        chatId,
        message: content,
      },
    })
  }

  return (
    <>
      {editMode ? (
        <AddMessage
          onCancel={() => setEditMode(false)}
          onAddNote={onAddNote}
          isLoading={addChatMessageMutationStatus.isLoading}
        />
      ) : (
        <PolicyCheckHOC policyName={POLICIES.isCreateChatMessageEnabled}>
          <Flex justify={'flex-end'}>
            <Button
              onClick={() => setEditMode(true)}
              variant="filled"
              className={styles['add-note-button']}
              leftSection={<Icons.Plus height={16} width={16} />}
            >
              New Note
            </Button>
          </Flex>
        </PolicyCheckHOC>
      )}
      <ChatList messages={messages ?? []} />
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  ChatMessages,
  POLICIES.isGetChatMessagesEnabled,
)
